module.exports = __webpack_public_path__ + "img/ar39_samurai01_shop.448935d1.png";